// extracted by mini-css-extract-plugin
export default {"loaderContainer":"ElementLoader_loaderContainer__PxU80","loader":"ElementLoader_loader__VG+sC","spinner":"ElementLoader_spinner__3mIt3","rotation":"ElementLoader_rotation__AuHc5"};